<div class="data-wrap" fxLayout="column">
    <div class="title" fxLayoutGap="5px" fxLayout="row wrap" fxLayoutAlign="start center">
        <mat-icon>save</mat-icon>
        <span i18n>Upload a new image</span>
    </div>

    <form fxLayoutGap="20px" fxLayout="column" [formGroup]="mediaForm">
        <app-user-setting-input
            type="text"
            i18n-placeholder
            [placeholder]="'Enter image name'"
            [control]="mediaForm.get('filename') | cast"
        >
            <label role="input-label" fxLayoutGap="4px">
                <span i18n>Image name</span>
            </label>
        </app-user-setting-input>
        <app-menu-side-media-upload-img
            *ngIf="!mediaForm.value.id"
            [allowedMimeType]="['image/png', 'image/jpg', 'image/jpeg']"
            [maxFileSize]="1 * 1024 * 1024"
            class="media-upload-img"
            (saving)="saving.emit($event)"
            (onMediaReady)="onUploadComplete($event)"
        >
        </app-menu-side-media-upload-img>
        <app-image-view
            *ngIf="mediaForm.value.id"
            [smallSpinner]="true"
            [media_id]="mediaForm.value.id"
            [proportional]="true"
        >
            <button
                class="remove-image"
                mat-icon-button
                color="warn"
                type="button"
                matTooltip="Remove image"
                i18n-matTooltip
                (click)="mediaForm.get('id').setValue(null); mediaForm.get('id').markAsDirty()"
            >
                <mat-icon class="md-18">delete_outline</mat-icon>
            </button>
        </app-image-view>
        <div class="input-field-parent" fxLayout="column" fxLayoutGap="5px">
            <span i18n>Description</span>
            <mat-form-field appearance="outline" floatLabel="never" class="w-100" fxFlex="grow">
                <textarea
                    #title
                    matInput
                    type="text"
                    formControlName="description"
                    placeholder="Enter image description"
                    i18n-placeholder
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="10"
                ></textarea>
            </mat-form-field>
        </div>
        <div
            *ngIf="mediaForm.value.visibility != 'master'"
            fxLayoutGap="4px"
            fxLayout="column"
            class="w-100 input-field-parent select"
        >
            <span i18n>Privacy</span>
            <mat-form-field class="role-field">
                <mat-select fxFlex="1 1 100%" formControlName="visibility">
                    <mat-option value="private" i18n>Private</mat-option>
                    <mat-option value="academy" i18n>Academy</mat-option>
                    <mat-option value="public" i18n>Public</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div fxLayoutGap="4px" fxLayout="column" class="w-100 input-field-parent k3-crm-tags">
            <span i18n>Tags</span>
            <app-tag-chip-select
                class="w-100"
                placeholder="Add Tag"
                [language_id]="currentLaguageId$ | async"
                i18n-placeholder
                formControlName="tag_ids"
            ></app-tag-chip-select>
        </div>

        <div class="action w-100" fxLayout="row" fxLayoutAlign="end center">
            <button
                [disabled]="!mediaForm.value.id"
                *ngIf="!(saving | async)"
                fxFlex="0 0 auto"
                class="mobile-button"
                (click)="submit()"
                mat-raised-button
            >
                <span i18n>Submit</span>
            </button>
            <ng-container *ngIf="saving | async">
                <app-saving-button></app-saving-button>
            </ng-container>
        </div>
    </form>
</div>
